import { useParams } from "react-router-dom";
import { useGetCommentHistoryQuery } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.api";
import moment from "moment";

const CommentHistoryTab = () => {
  const { id } = useParams();
  const { data: commentHistories } = useGetCommentHistoryQuery(id);
  return (
    <div className="h-[calc(100vh_-_385px)] w-full overflow-auto px-1">
      {commentHistories?.data?.map((item: any) => (
        <div
          key={item.id}
          className="p-4 bg-white shadow rounded-md w-full mx-auto mb-2"
        >
          <div className="flex justify-start items-center">
            <p>Editor :</p>
            <p className="pl-2">{item?.user?.officialInfo?.name}</p>
          </div>

          <div className="flex justify-start items-center">
            <p>Old comment :</p>
            <p className="pl-2">{item?.old_comment}</p>
          </div>

          <div className="flex justify-start items-center">
            <p>New comment :</p>
            <p className="pl-2">{item?.comment}</p>
          </div>
          <p className="text-[#3D4A5C] text-base">
            {moment(item?.updated_at).fromNow()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CommentHistoryTab;
